/** @format */

interface SubscriptionWithTrialInfo {
  planId?: number | null;
  isTrial?: boolean;
}

const isTrialSubscription = <S extends SubscriptionWithTrialInfo>(subscription?: S): boolean => {
  return Boolean(subscription?.planId === null || subscription?.isTrial);
};

export {isTrialSubscription};
